<template>
	<div class="study">
		<publicHeader></publicHeader>
		<div class="help_header bg_gray">
			<div class="w1200 flex">
				<div class="flex">
					<img :src="public.top_logo" class="study_header_logo" />
					<div class="f20px study_header_name">·&nbsp;&nbsp;&nbsp;&nbsp;帮助中心</div>
				</div>
			</div>
		</div>
		<div class="help_screen tc">
			<div class="w1200">
				<p class="f26px cl_white help_screen_top">欢迎使用趣学云课堂帮助中心</p>
				<div class="study_header_r bg_white">
					<input type="text" v-model="searchText" placeholder="请输入问题关键词" class="f16px" />
					<div class="study_header_btn cl_white f18px" @click="searchBtn"><img src="../../../static/search_white.png" /><span>搜一搜</span></div>
				</div>
			</div>
		</div>
		<div class="help_cont bg_gray">
			<div class="w1200 bg_white radius8">
				<div class="help_item_cont" v-if="list.length > 0">
					<div class="help_item" v-for="(item,index) in list" :key="index">
						<router-link :to="{ path: '/help_details', query: { id: item.id }}" class="f18px">{{item.name}}</router-link>
						<p class="f16px cl_gray mat5">{{item.remark}}</p>
					</div>
				</div>
				<div class="help_item_cont tc f18px cl_gray" v-if="list.length ==0">
					<p>抱歉，找不到相关问题</p>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'help_list',
		components: {
			publicHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				public: {},
				searchText: "",
				id: "",
				list: [],
			}
		},
		mounted() {
			this.getList();
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
			}
			if (this.$route.query.name) {
				this.searchText = this.$route.query.name;
			} 
		},
		watch: {
			$route: {
				handler () {
					this.searchText = this.$route.query.name;
					this.getList();
				}
			}
		},
		methods: {
			publicEvent (data) {
				this.public = data;
			},
			getList () {
				this.$get("/api/article/get_article_list",{
					name: this.searchText,
					cate_id: this.id,
				})
				.then(res => {
					this.list = res.data.data;
				});
			},
			searchBtn () {
				if (this.searchText != "") {
					this.$router.push({path:'/help_list',query: {name:this.searchText}})
				}
			},
		},
	}
</script>

<style>
</style>
